// **********************************************************
// Language Switch
// **********************************************************
const languageSwitch = document.querySelector('.language-switch');

if (languageSwitch) {
  attachEvent('.language-switch__button', 'click', (el) => {
    const parent = el.target.closest('.language-switch');
    parent?.classList.toggle('is-open');
  });

  document.addEventListener('click', (event) => {
    if (!languageSwitch?.contains(event.target)) {
      languageSwitch?.classList.remove('is-open');
    }
  });
}
